import { format, parseISO, isValid } from 'date-fns';

/**
 * @typedef {import('date-fns').Locale} DateFnsLocale
 * @typedef {{ locale?: DateFnsLocale }} FormatDateWithPatternOptions
 */

/**
 * Converte valor de entrada em um objeto Date válido.
 * @param {string|Date|number|null|undefined} value - Data como string (ISO ou 'YYYY-MM-DD'), Date ou timestamp em ms
 * @returns {Date|null} Date ou null se inválido
 */
const toDate = (value) => {
  if (value == null) return null;
  if (value instanceof Date) return isValid(value) ? value : null;
  if (typeof value === 'number') {
    const d = new Date(value);
    return isValid(d) ? d : null;
  }
  if (typeof value === 'string') {
    if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const d = new Date(`${value} 00:00:00`);
      return isValid(d) ? d : null;
    }
    const d = parseISO(value);
    return isValid(d) ? d : null;
  }
  return null;
};

/**
 * Formata uma data conforme o padrão informado (sintaxe date-fns).
 * Útil para formatos genéricos como "d MMM" (ex.: "1 Jan"), "dd/MM/yyyy", etc.
 *
 * @param {string|Date|number} date - Data como string (ISO ou 'YYYY-MM-DD'), Date ou timestamp em ms
 * @param {string} pattern - Padrão de formatação date-fns (ex.: 'd MMM', 'dd/MM/yyyy')
 * @param {FormatDateWithPatternOptions} [options] - Opções do date-fns (ex.: { locale: ptBR })
 * @returns {string} Data formatada ou string vazia se a data for inválida
 *
 * @example
 * formatDateWithPattern('2024-01-15', 'd MMM')      // '15 Jan'
 * formatDateWithPattern('2024-01-15', 'dd/MM/yyyy') // '15/01/2024'
 */
export const formatDateWithPattern = (date, pattern, options = {}) => {
  const d = toDate(date);
  if (!d) return '';
  return format(d, pattern, options);
};
